<template>
  <div class="index" v-cloak>
    <div class="index-bg" :style="{backgroundImage:`url(${require('@assets/images/dywfl/background.jpg')})`}">
      <!-- <img src="@assets/images/dywfl/background.jpg" alt=""> -->
    </div>
    <div class="street-list" v-for="(item,index) in cate_list">
      <div class="street-title">·{{item.title}}</div>
      <div class="area-list">
        <div class="area-item" v-for="(aitem,aindex) in item.children">
          <img :src="aitem.image" alt="" @click="goList(aitem.id)">
        </div>
      </div>
    </div>
    <div class="index-botom" style="height: 1rem"></div>
  </div>
</template>

<script>
import { getHomeData, getShare, follow, getFulianCate } from "@api/public";

import cookie from "@utils/store/cookie";

export default {
  name: "CateList",
  components: {
  },
  props: {},
  data: function () {
    return {
      pid: 0, //分类id
      cate_list: [], //分类列表
      history_pid:[],//分类历史
    };
  },
  mounted: function () {
    let that = this;
    // let history_pid = that.history_pid;
    that.pid = that.$route.query.pid;
    // history_pid.push()
    // that.history_pid = history_pid;
    that.getFulianCate();
  },
  methods: {
    getFulianCate: function () {
      let that = this;
      let pid = that.pid;
      getFulianCate(pid).then((res) => {
        let list = res.data;
        // if(res.data.length <=0){
        //   this.$router.push({ path: "/news/list",query: { id: pid } });
        // }
        that.$set(that, "cate_list", list);
        // that.getAreaCate(list);
      });
    },
    goList:function(id){
      this.$router.push({ path: "/news/list",query: { id: id } });
    }
  },
};
</script>
<style scoped>
.index-bg{
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: -1;
  background-size: cover;
  background-repeat: no-repeat;
}
.street-list{
  margin: 0 .3rem;
}
.street-title{
  font-size: .4rem;
  font-weight: bold;
  font-family: '楷体';
  padding: .4rem 0 .1rem;
  border-bottom: 1px solid #B5B39F;
  margin-bottom: .1rem;
}
.area-list{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  background: #F0DCB6;
}
.area-item{
  width: 25%;
}
.area-item img{
  width: 100%;
  vertical-align: bottom;
}
</style>
